import { useContext } from "react";
import TabBar, { TabBarProps } from "../../../shared/components/TabBar";
import Content from "../Content";
import ProductCategoryGroups from "../ProductCategoryGroups";
import ProductExportImportHistory from "../ProductExportImportHistory";
import ProductImportHistory from "../ProductImportHistory";
import ProductQuantityTrackingTab from "../ProductQuantityTrackingTab";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import { ROLE } from "../../../data/enums";

const ProductsTabNavigations = () => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);

    const tabs: TabBarProps[] = [
        {
            label: "Danh sách sản phẩm",
            labelEN: "product-list",
            content: <Content />,
        },
        {
            label: "Quản lý nhóm sản phẩm",
            labelEN: "product-category-group-management",
            content: <ProductCategoryGroups />,
        },
        {
            label: "Phiếu nhập kho",
            labelEN: "product-import-history",
            content: <ProductImportHistory />,
        },
        {
            label: "Phiếu xuất kho",
            labelEN: "product-export-history",
            content: <ProductExportImportHistory />,
        },
        {
            label: "Nhập xuất tồn",
            labelEN: "product-quantity-tracking",
            content: <ProductQuantityTrackingTab />,
        },
    ];

    const getTabs = () => {
        switch (role) {
            case ROLE.FACTORY_MANAGER_ONE:
            case ROLE.FACTORY_MANAGER_TWO:
            case ROLE.DEPUTY_FACTORY_MANAGER_ONE:
            case ROLE.DEPUTY_FACTORY_MANAGER_TWO:
                return tabs.filter(
                    (tab) =>
                        ["product-list", "product-import-history", "product-export-history"].includes(
                            tab.labelEN as string,
                        ),
                );
            default:
                return tabs;
        }
    };

    return <TabBar tabs={getTabs()} tabParamName="tab" defaultTab="product-list" />;
};

export default ProductsTabNavigations;
